export const courseFilters = [
  ["all", "Todos"],
  ["in_progress", "Em andamento"],
  ["completed", "Concluídos"],
  ["unavailable", "Bloqueados"],
] as const;

export type CourseFilter = (typeof courseFilters)[number][0];

export function courseCatalogSearch(search: Record<string, unknown>): {
  q?: string;
  filter?: CourseFilter;
} {
  return {
    q: typeof search.q === "string" && search.q ? search.q : undefined,
    filter: courseFilters.find(([value]) => value === search.filter && value !== "all")?.[0],
  };
}
